import {
    DATA_LOADED,
    LOADING_DATA,
    SET_ADMIN,
    TOGGLE_SENSORS,
    TOGGLE_CREATE_SENSORS,
    NEW_MAP_ALERT_HIDE,
    NEW_MAP_ALERT_SHOW,
    POST_NEW_MAP,
    SET_IOT_SENSOR_TRUE,
    SET_IOT_SENSOR_FALSE,
    TOGGLE_CHART,
    DISABLE_NOTIFICATION,
    CANCEL_SUBSCRIPTION_ID,
    ADD_SUBSCRIPTION_ID
} from "../../actions/app";

const initialState = {
    lat: 41.4050,
    lng: 2.1734,
    isDataStored: false,
    hideSensors: false,
    hideChart: false,
    createSensors: false,
    isAdmin: false,
    isLoading: false,
    notificationEnabled: true,
    popUp: false,
    newMap: null,
    IoTsensor: false,
    subId : null
}

const app = (state = initialState, action) => {
    switch (action.type) {
        case ADD_SUBSCRIPTION_ID:
            return {
                ...state,
                subId: action.subId
            }

        case CANCEL_SUBSCRIPTION_ID:
            return {
                ...state,
                subId: null
            }

        case DISABLE_NOTIFICATION:
            return {
                ...state,
                notificationEnabled: false,
                popUp: false
            }
        case TOGGLE_CHART:
            return {
                ...state,
                hideChart: !state.hideChart
            }

        case SET_IOT_SENSOR_FALSE:
            return {
                ...state,
                IoTsensor: false
            }

        case SET_IOT_SENSOR_TRUE:
            return {
                ...state,
                IoTsensor: true
            }

        case POST_NEW_MAP:
            return {
                ...state,
                newMap: action.mapSocket,
            }
        case SET_ADMIN:
            return {
                ...state,
                isAdmin: action.admin,
            }

        case TOGGLE_SENSORS:
            return {
                ...state,
                hideSensors: !state.hideSensors
            }
        case LOADING_DATA:
            return {
                ...state,
                isLoading: true,
            }

        case DATA_LOADED:
            return {
                ...state,
                isLoading: false,
            }

        case TOGGLE_CREATE_SENSORS:
            return {
                ...state,
                createSensors: !state.createSensors
            }

        case NEW_MAP_ALERT_SHOW:
            return {
                ...state,
                popUp: true
            }
        case NEW_MAP_ALERT_HIDE:
            return {
                ...state,
                popUp: false
            }
        default:
            return state
    }
}

export default app



// WEBPACK FOOTER //
// ./src/reducers/map/app.js